<template>
  <div
    class="relative my-4 flex w-full cursor-pointer flex-col items-start rounded-md outline-none"
    :class="{
      'border-none': open,
    }"
    :tabindex="tabindex"
    @blur="open = false"
  >
    <label
      v-if="label"
      class="mb-1 text-left text-xxs font-bold uppercase text-gray-over-dark"
      :class="[customClass]"
      :for="label"
    >
      {{ label }}
    </label>
    <div
      class="flex h-12 w-full cursor-pointer items-center justify-between gap-2 rounded-md border border-transparent bg-off-white px-2"
      :class="[{ open: open }, { 'light-bg': light }]"
      @click="open = !open"
    >
      <p class="text-sm font-normal text-steel-800">
        {{ value || (isObject ? selected?.value : selected) }}
      </p>
      <img
        class="transition"
        :class="{ '-rotate-180 transform': open }"
        src="@/assets/arrow-down-gray.svg"
        alt="arrow icon"
      />
    </div>
    <div
      class="absolute top-[38px] z-20 flex w-full flex-col items-start overflow-hidden rounded-b-md border-b border-l border-r border-body-color bg-white"
      :class="[{ hidden: !open }, { light: changePosition }]"
    >
      <p
        v-for="(option, i) of options"
        :key="i"
        class="w-full px-4 py-2 text-left font-normal text-steel-700 hover:bg-lighter-gray"
        :class="i === 0 ? 'mt-2' : ''"
        @click="
          selected = option;
          open = false;
          $emit('input', option);
        "
      >
        {{ isObject ? option?.value : option }}
      </p>
    </div>
  </div>
</template>

<script>
export default {
  name: 'LoadDropdownSelect',
  props: {
    options: {
      type: Array,
      required: true,
    },
    value: {
      type: String,
      required: false,
    },
    default: {
      type: [String, Object],
      required: false,
      default: null,
    },
    tabindex: {
      type: Number,
      required: false,
      default: 0,
    },
    label: String,
    customClass: {
      type: String,
      default: '',
    },
    isObject: {
      type: Boolean,
      default: false,
    },
    emitOnMount: {
      type: Boolean,
      default: true,
    },
    light: {
      type: Boolean,
      default: false,
    },
    changePosition: {
      type: Boolean,
      default: false,
    },
  },
  data() {
    return {
      selected: this.default
        ? this.default
        : this.options.length > 0
          ? this.options[0]
          : null,
      open: false,
    };
  },
  computed: {
    filterFor: function () {
      return this.options.filter((el) => el !== this.selected);
    },
  },
};
</script>
<style scoped>
.open {
  @apply rounded-b-none rounded-t-md border-l border-r border-t border-steel-700;
  background: #fff !important;
}
.open:hover {
  @apply border-body-color;
}

.light {
  top: 40px !important;
}

.light-bg {
  background: white !important;
}
</style>
